import { render, staticRenderFns } from "./Delegate.vue?vue&type=template&id=05df5dfe"
import script from "./Delegate.vue?vue&type=script&lang=ts"
export * from "./Delegate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports